import {connect} from '@modifi/redux'
import {aPush} from '@modifi/router'

import CompanyFinancials, {CompanyFinancialsProps} from './CompanyFinancials'
import {
  aReset,
  aSavePage,
  selectInitialFormData,
  selectSaveErrorMessage,
  selectSavePending,
} from './store'
import {ROUTE_INTRO} from '../../../../routes/constants'
import {PRE_UNDERWRITING_BUYER_DETAILS, PRE_UNDERWRITING_COMPANY_INTRODUCTION} from '../constants'

const mapStateToProps = (
  state: Record<string, any>
): Pick<CompanyFinancialsProps, 'saveErrorMessage' | 'savePending' | 'formData'> => ({
  saveErrorMessage: selectSaveErrorMessage(state),
  savePending: selectSavePending(state),
  formData: selectInitialFormData(state),
})

const mapDispatchToProps = {
  onSubmit: aSavePage,
  onDiscard: (): any => aReset(),
  redirectToCompanyIntroduction: (): any =>
    aPush(ROUTE_INTRO, {page: PRE_UNDERWRITING_COMPANY_INTRODUCTION}),
  redirectToBuyerDetails: (): any => aPush(ROUTE_INTRO, {page: PRE_UNDERWRITING_BUYER_DETAILS}),
}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyFinancials)
